'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'telescope';
var width = 640;
var height = 512;
var aliases = [128301];
var unicode = 'e03e';
var svgPathData = ['M488.6 269.9l-96.7 33.73c-.1914-39.75-32.58-71.82-72.33-71.63C279.1 232.2 247.1 264.4 247.1 304c.0801 15.91 5.387 31.29 15.27 43.76l-127 43.69c-8.754 3.008-18.05-.7051-21.27-8.479L106.2 361.9L42.18 388.4c-8.162 3.381-17.52-.4935-20.9-8.658l-20.06-48.42c-3.377-8.166 .4967-17.52 8.659-20.91l64.08-26.55L65.21 262.8C61.99 254.1 65.93 245.8 74.25 241.7l335.1-163.2L488.6 269.9z', 'M638.8 216.8C638.8 216.8 638.8 216.8 638.8 216.8l-85.7-206.1c-3.381-8.162-12.77-12.03-20.94-8.647l-117.3 48.61c-8.162 3.381-12.06 12.73-8.68 20.89c.002 .002 0-.002 0 0l85.73 206.9c3.383 8.164 12.73 12.07 20.9 8.689l117.3-48.61C638.3 234.4 642.2 225 638.8 216.8zM422.6 479.1l-46.42-131.5c9.734-12.28 15.79-27.6 15.79-44.49c0-39.77-32.24-72-72.01-72c-39.76 0-71.99 32.24-71.99 72.01c0 16.89 6.06 32.18 15.79 44.46L217.4 479.1c-4.406 12.5 2.126 26.22 14.63 30.63C234.6 511.6 237.3 512 239.1 512c9.875 0 19.16-6.157 22.63-16l42.9-121.6c4.686 .959 9.507 1.551 14.48 1.551s9.822-.5039 14.51-1.463l42.87 121.5C380.8 505.8 390.1 512 399.1 512c2.656 0 5.344-.4375 8.001-1.375C420.5 506.2 427 492.5 422.6 479.1zM295.1 303.1c0-13.23 10.77-24 24-24c13.23 0 24 10.77 24 24c0 13.23-10.77 24-24 24C306.8 327.1 295.1 317.2 295.1 303.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTelescope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;